@if (type === 'number') {
  <div class="badge-content">
    <span class="number-text">{{ number }}</span>
  </div>
}

@if (type !== 'number' && filled) {
  <cs-status-icon [tone]="getStatusIconTone()" [icon]="getIconName()"></cs-status-icon>
} @else if (type !== 'number') {
  <cs-icon [name]="getIconName()"></cs-icon>
}
